import React from 'react'

export const LoadingIndicator = () => {
  return <div>loading...</div>
}
